import { render } from "./typeDictionary.vue?vue&type=template&id=e86d9fc8"
import script from "./typeDictionary.vue?vue&type=script&lang=js"
export * from "./typeDictionary.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__